// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","group":"_1VDRpdlKdjAT","group__label":"E0MOTVPVGgiC"};